import approved from './approved.svg?url';
import binoculars from './binoculars.svg?url';
import caution from './caution.svg?url';
import check from './check.svg?url';
import cone from './cone.svg?url';
import cursor from './cursor.svg?url';
import filteredToNothingDark from './filtered-to-nothing-dark.svg?url';
import filteredToNothing from './filtered-to-nothing.svg?url';
import handCursor from './hand-cursor.svg?url';
import monocular from './monocular.svg?url';
import noPermission from './no-permission.svg?url';
import notSetUp from './not-set-up.svg?url';
import notSupported from './not-supported.svg?url';
import percent from './percent.svg?url';
import puzzle from './puzzle.svg?url';
import shoes from './shoes.svg?url';
import uhOhDark from './uh-oh-dark.svg?url';
import uhOh from './uh-oh.svg?url';
import warning from './warning.svg?url';
import zeroData from './zero-data.svg?url';

const emptyStateIllustrations = {
	approved,
	binoculars,
	caution,
	check,
	cone,
	cursor,
	'filtered-to-nothing': filteredToNothing,
	'hand-cursor': handCursor,
	monocular,
	'no-permission': noPermission,
	'not-set-up': notSetUp,
	'not-supported': notSupported,
	percent,
	puzzle,
	shoes,
	'uh-oh': uhOh,
	warning,
	'zero-data': zeroData,
};

type EmptyStateIllustration = keyof typeof emptyStateIllustrations;

const emptyStateDarkIllustrations: Partial<Record<EmptyStateIllustration, string>> = {
	'filtered-to-nothing': filteredToNothingDark,
	'uh-oh': uhOhDark,
};

export { emptyStateIllustrations, emptyStateDarkIllustrations };
export type { EmptyStateIllustration };
